import React from 'react';
import CapacityPlantTemplate from '../../components/CapacityPlantTemplate';
import { capacityPlants } from '../../data/capacityPlants';

const WaterPlant120BPM = () => (
  <CapacityPlantTemplate plant={capacityPlants['/120-bpm-water-plant']} path="/120-bpm-water-plant" />
);

export default WaterPlant120BPM;
